<template>
  <v-container fluid>
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon icon="mdi-medical-bag" class="mr-2" color="red"></v-icon>
        Trazabilidad de Dispositivos Médicos
        <v-chip class="ml-2" color="info" size="small">Norma N° 247</v-chip>
      </v-card-title>

      <!-- Dashboard de Métricas -->
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <v-card color="primary" dark>
              <v-card-text>
                <div class="text-h4">{{ estadisticas.total_dm || 0 }}</div>
                <div class="text-caption">Total DM en Sistema</div>
              </v-card-text>
            </v-card>
          </v-col>
          
          <v-col cols="12" md="3">
            <v-card color="warning" dark>
              <v-card-text>
                <div class="text-h4">{{ estadisticas.transferencias_pendientes || 0 }}</div>
                <div class="text-caption">Transferencias Pendientes</div>
              </v-card-text>
            </v-card>
          </v-col>
          
          <v-col cols="12" md="3">
            <v-card color="success" dark>
              <v-card-text>
                <div class="text-h4">{{ estadisticas.implantes_activos || 0 }}</div>
                <div class="text-caption">Implantes Activos</div>
              </v-card-text>
            </v-card>
          </v-col>
          
          <v-col cols="12" md="3">
            <v-card color="info" dark>
              <v-card-text>
                <div class="text-h4">{{ estadisticas.dm_por_servicio || 0 }}</div>
                <div class="text-caption">Servicios Clínicos</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Navegación a Módulos -->
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-card 
              hover 
              @click="activeTab = 'transferencias'"
              :color="activeTab === 'transferencias' ? 'primary' : ''"
              :variant="activeTab === 'transferencias' ? 'flat' : 'outlined'"
            >
              <v-card-text class="text-center">
                <v-icon size="64" :color="activeTab === 'transferencias' ? 'white' : 'primary'">
                  mdi-arrow-right-bold-circle
                </v-icon>
                <div class="text-h6 mt-2" :class="activeTab === 'transferencias' ? 'text-white' : ''">
                  Transferencias
                </div>
                <div class="text-caption" :class="activeTab === 'transferencias' ? 'text-white' : ''">
                  Gestionar transferencias entre servicios
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card 
              hover 
              @click="activeTab = 'implantes'"
              :color="activeTab === 'implantes' ? 'primary' : ''"
              :variant="activeTab === 'implantes' ? 'flat' : 'outlined'"
            >
              <v-card-text class="text-center">
                <v-icon size="64" :color="activeTab === 'implantes' ? 'white' : 'primary'">
                  mdi-account-heart
                </v-icon>
                <div class="text-h6 mt-2" :class="activeTab === 'implantes' ? 'text-white' : ''">
                  Implantes
                </div>
                <div class="text-caption" :class="activeTab === 'implantes' ? 'text-white' : ''">
                  Registrar implantes en pacientes
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="3">
            <v-card 
              hover 
              @click="activeTab = 'estados'"
              :color="activeTab === 'estados' ? 'primary' : ''"
              :variant="activeTab === 'estados' ? 'flat' : 'outlined'"
            >
              <v-card-text class="text-center">
                <v-icon size="64" :color="activeTab === 'estados' ? 'white' : 'primary'">
                  mdi-state-machine
                </v-icon>
                <div class="text-h6 mt-2" :class="activeTab === 'estados' ? 'text-white' : ''">
                  Estados
                </div>
                <div class="text-caption" :class="activeTab === 'estados' ? 'text-white' : ''">
                  Cambiar estado de dispositivos
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="3">
            <v-card 
              hover 
              @click="activeTab = 'historial'"
              :color="activeTab === 'historial' ? 'primary' : ''"
              :variant="activeTab === 'historial' ? 'flat' : 'outlined'"
            >
              <v-card-text class="text-center">
                <v-icon size="64" :color="activeTab === 'historial' ? 'white' : 'primary'">
                  mdi-timeline-clock
                </v-icon>
                <div class="text-h6 mt-2" :class="activeTab === 'historial' ? 'text-white' : ''">
                  Historial Completo
                </div>
                <div class="text-caption" :class="activeTab === 'historial' ? 'text-white' : ''">
                  Ver trazabilidad completa de un DM
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Contenido de Módulos -->
      <v-card-text>
        <v-window v-model="activeTab">
          <v-window-item value="transferencias">
            <TransferenciaDM @refresh="fetchEstadisticas" />
          </v-window-item>

          <v-window-item value="implantes">
            <ImplanteDM @refresh="fetchEstadisticas" />
          </v-window-item>

          <v-window-item value="estados">
            <EstadoDM @refresh="fetchEstadisticas" />
          </v-window-item>

          <v-window-item value="historial">
            <HistorialCompletoDM />
          </v-window-item>
        </v-window>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import TransferenciaDM from '@/components/trazabilidad/TransferenciaDM.vue'
import ImplanteDM from '@/components/trazabilidad/ImplanteDM.vue'
import EstadoDM from '@/components/trazabilidad/EstadoDM.vue'
import HistorialCompletoDM from '@/components/trazabilidad/HistorialCompletoDM.vue'
import apiClient from '@/api'

export default {
  name: 'TrazabilidadDM',
  components: {
    TransferenciaDM,
    ImplanteDM,
    EstadoDM,
    HistorialCompletoDM
  },
  data() {
    return {
      activeTab: 'transferencias',
      estadisticas: {
        total_dm: 0,
        transferencias_pendientes: 0,
        implantes_activos: 0,
        dm_por_servicio: 0
      },
      loading: false
    }
  },
  mounted() {
    this.fetchEstadisticas()
  },
  methods: {
    async fetchEstadisticas() {
      this.loading = true
      try {
        const response = await apiClient.get('/dm/estadisticas')
        this.estadisticas = response.data
      } catch (error) {
        console.error('Error al cargar estadísticas:', error)
        // Usar datos mock si falla
        this.estadisticas = {
          total_dm: 0,
          transferencias_pendientes: 0,
          implantes_activos: 0,
          dm_por_servicio: 0
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.v-card:hover {
  cursor: pointer;
}
</style>

